import { useResolvedUser } from "./useResolvedUser";

/** Shows both halves of the identity, so the reader never has to decode an eMAID. */
const UserHeading = ({ emaid }: { emaid: string }) => {
  const { email } = useResolvedUser(emaid);

  return (
    <div className="flex flex-column" data-testid="user-heading">
      <span className="font-semibold">{emaid}</span>
      {email ? (
        <span className="text-sm text-color-secondary">{email}</span>
      ) : (
        <span className="text-xs text-color-secondary">no account email found</span>
      )}
    </div>
  );
};

export default UserHeading;
